import { useEffect } from "react";

const SITE = "https://mindfulmeyourcalmcompanion.com";
const IMAGE = `${SITE}/og-image.jpg`;
const DEFAULT_TITLE = "Mindful Me - Mental Wellness Companion";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

// Per-page search + share preview tags for public pages
export const usePageMeta = ({ title, description, path, image = IMAGE }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    [["og:title", title], ["og:description", description], ["og:url", url], ["og:image", image], ["og:type", "website"], ["og:site_name", "Mindful Me"]]
      .forEach(([k, v]) => setMeta("property", k, v));
    [["twitter:card", "summary_large_image"], ["twitter:title", title], ["twitter:description", description], ["twitter:image", image]]
      .forEach(([k, v]) => setMeta("name", k, v));
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    return () => { document.title = DEFAULT_TITLE; link.remove(); };
  }, [title, description, path, image]);
};
